declare namespace $ {

	type $bog_wikilive_tree_node__page_link_bog_wikilive_tree_1 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree['root_page_link'] >
		,
		ReturnType< $bog_wikilive_tree_node['page_link'] >
	>
	type $bog_wikilive_tree_node__store_bog_wikilive_tree_2 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree['store'] >
		,
		ReturnType< $bog_wikilive_tree_node['store'] >
	>
	type $bog_wikilive_tree_node__level_bog_wikilive_tree_3 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_wikilive_tree_node['level'] >
	>
	type $bog_wikilive_tree_node__page_selected_bog_wikilive_tree_4 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree['page_selected'] >
		,
		ReturnType< $bog_wikilive_tree_node['page_selected'] >
	>
	export class $bog_wikilive_tree extends $mol_list {
		root_nodes( ): readonly(any)[]
		root_page_link( id: any): string
		page_selected( next?: string ): string
		store( ): $bog_wikilive_store
		rows( ): ReturnType< $bog_wikilive_tree['root_nodes'] >
		Root_node( id: any): $bog_wikilive_tree_node
	}
	
}

//# sourceMappingURL=tree.view.tree.d.ts.map